import _createForOfIteratorHelper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module table/commands/selectrowcommand
 */
import { Command } from 'ckeditor5/src/core.js';
/**
 * The select row command.
 *
 * The command is registered by {@link module:table/tableediting~TableEditing} as the `'selectTableRow'` editor command.
 *
 * To select the rows containing the selected cells, execute the command:
 *
 * ```ts
 * editor.execute( 'selectTableRow' );
 * ```
 */
var SelectRowCommand = /*#__PURE__*/function (_Command) {
  _inherits(SelectRowCommand, _Command);
  var _super = _createSuper(SelectRowCommand);
  /**
   * @inheritDoc
   */
  function SelectRowCommand(editor) {
    var _this;
    _classCallCheck(this, SelectRowCommand);
    _this = _super.call(this, editor);
    // It does not affect data so should be enabled in read-only mode.
    _this.affectsData = false;
    return _this;
  }
  /**
   * @inheritDoc
   */
  _createClass(SelectRowCommand, [{
    key: "refresh",
    value: function refresh() {
      var tableUtils = this.editor.plugins.get('TableUtils');
      var selectedCells = tableUtils.getSelectionAffectedTableCells(this.editor.model.document.selection);
      this.isEnabled = selectedCells.length > 0;
    }
    /**
     * @inheritDoc
     */
  }, {
    key: "execute",
    value: function execute() {
      var model = this.editor.model;
      var tableUtils = this.editor.plugins.get('TableUtils');
      var referenceCells = tableUtils.getSelectionAffectedTableCells(model.document.selection);
      var rowIndexes = tableUtils.getRowIndexes(referenceCells);
      var table = referenceCells[0].findAncestor('table');
      var rangesToSelect = [];
      for (var rowIndex = rowIndexes.first; rowIndex <= rowIndexes.last; rowIndex++) {
        var _iterator = _createForOfIteratorHelper(table.getChild(rowIndex).getChildren()),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var cell = _step.value;
            rangesToSelect.push(model.createRangeOn(cell));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      model.change(function (writer) {
        writer.setSelection(rangesToSelect);
      });
    }
  }]);
  return SelectRowCommand;
}(Command);
export { SelectRowCommand as default };